export const pathName = (location) => {
    let pathName = location.pathname.replace(/\//g, "");
    let capitalizedPathName = pathName.charAt(0).toUpperCase() + pathName.slice(1);

    return capitalizedPathName;
}
export const urlRegex = /^(http:\/\/|https:\/\/)(www\.)?([a-zA-Z0-9.-]+\.(com|org|net|info|edu|biz|co))(:[0-9]{1,5})?(\/\S*)?$/;